import { render, staticRenderFns } from "./BayLItem.vue?vue&type=template&id=28256840&scoped=true&"
import script from "./BayLItem.vue?vue&type=script&lang=js&"
export * from "./BayLItem.vue?vue&type=script&lang=js&"
import style0 from "./BayLItem.vue?vue&type=style&index=0&id=28256840&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28256840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28256840')) {
      api.createRecord('28256840', component.options)
    } else {
      api.reload('28256840', component.options)
    }
    module.hot.accept("./BayLItem.vue?vue&type=template&id=28256840&scoped=true&", function () {
      api.rerender('28256840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/coms/BayLItem.vue"
export default component.exports